import SaleGlobalSearch from './SaleGlobalSearch';

export default SaleGlobalSearch;
